import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowRightStyle0 = cosmosIconCss;

const CosmosIconArrowRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '82c0d0993e6e2b9ab8945dcab10aa01e9fcf3557', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'aed8bfe76f12346bf46e7013077e8c29f1a45095', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3f1af249b1b20d7f95dbc94ef8d68b7342d82ac5', d: "m15.285 11.75-3.146 3.145a.5.5 0 0 0 0 .707l.354.354a.5.5 0 0 0 .707 0l4.596-4.596a.499.499 0 0 0 .146-.357.499.499 0 0 0-.146-.357L13.2 6.05a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l3.14 3.139H4.56a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10.724Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowRightStyle0; }
}, [1, "cosmos-icon-arrow-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowRight$1);
            }
            break;
    } });
}

const CosmosIconArrowRight = CosmosIconArrowRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowRight, defineCustomElement };
